import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ApiStatus} from '../../../models';
import {
  executeBlock,
  unsetBlockExecution,
} from '../../../store/actions/blockResultActions';
import {
  getBlockExecutionStatusSelector
} from '../../../store/reducers/blockResultReducer';
import {useSourceType, useSourceId} from '../SourceContext';
import {CONTEXT_TYPE} from '../constants';

export function useExecuteRequest(
  uid: string | undefined,
): any {
  /*
   * sourceId can be either a Report or a Notebook
   */
  const [executing, setExecuting] = useState(false);
  const executionLoading = useSelector(getBlockExecutionStatusSelector(uid));
  const sourceId = useSourceId();
  const sourceType = useSourceType();
  const dispatch = useDispatch();

  useEffect(() => {
    /*
     * If execution is finished, reset executing flag.
     */
    if (executing && executionLoading !== ApiStatus.LOADING) {
      if (
        executionLoading === ApiStatus.LOADED ||
        executionLoading === ApiStatus.FAILED
      ) {
        setExecuting(false);
        dispatch(unsetBlockExecution(uid as string));
      }
    }
  }, [uid, executing, executionLoading]);

  const executeRequest = (block: any) => {
    if (executing || !uid) {
      return;
    }
    setExecuting(true);

    const newBlock: any = {
      content_json: {
        ...block.content_json,
      }
    }

    const reportUid = sourceType === CONTEXT_TYPE.REPORT ? sourceId : null;

    dispatch(executeBlock(
      uid,
      reportUid,
      newBlock)
    );
  };

  return {
    executing,
    executeRequest
  };
}
